import type { IRestModel } from "@nkr/utils/rest-api";
import { RestApi } from "@nkr/utils/rest-api";

export interface IDonorMentorCannedResponse extends IRestModel {
    id: number,
    name: string,
    emailSubject: string,
    emailContent: string,
}

export interface IDonorMentorSendEmailRequest {
    recipients: string[],
    emailSubject: string,
    emailContent: string,
}

const DONOR_MENTOR_CANNED_RESPONSE_API_PATH = `${__API__}/donor-connect/canned-response`;
const DONOR_MENTOR_EMAIL_API_PATH = `${__API__}/donor-connect/{registrationId}/email`;

export const DonorMentorCannedResponseApi = new RestApi<IDonorMentorCannedResponse, IDonorMentorCannedResponse>(DONOR_MENTOR_CANNED_RESPONSE_API_PATH)
    .makeHooks();

export const useDonorMentorCannedResponseSenderApi = (registrationId: string | number) => {
    const resolvedRegistrationId = registrationId || "{registrationId}";
    const apiPath = DONOR_MENTOR_EMAIL_API_PATH.replace("{registrationId}", resolvedRegistrationId.toString());
    const instance = new RestApi<IDonorMentorCannedResponse, IDonorMentorCannedResponse>(apiPath);
    return instance.makeHooks();
};
